// Central brand + contact configuration (NAP consistency for Local SEO)
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" && window.location.hostname !== "localhost"
    ? window.location.origin
    : "https://dmsproductions.in");

export const BRAND = {
  name: "DMS Productions & Films",
  shortName: "DMS Productions",
  tagline: "Luxury Wedding Photography & Cinematic Films in Bhubaneswar & Odisha",
  description:
    "Luxury wedding photographer in Bhubaneswar & Odisha crafting editorial fine-art wedding stories, pre-wedding shoots, and cinematic films across Puri, Kolkata, Hyderabad & destination weddings.",
  email: "dmsproductionsfilms@gmail.com",
  phones: ["9090715566", "9853939729"],
  phoneFormatted: ["+91 9090715566", "+91 9853939729"],
  whatsappNumber: "919853939729",
  address: {
    street: "Duplex No. 29, Duplex Society, Bhimpur, Forest Park",
    locality: "Bhubaneswar",
    region: "Odisha",
    postalCode: "751020",
    country: "IN",
    fullAddress: "Duplex No. 29, Duplex Society, Bhimpur, Forest Park, Bhubaneswar, Odisha 751020, India",
    geo: {
      latitude: "20.2541",
      longitude: "85.8249",
    },
  },
  serviceAreas: ["Bhubaneswar", "Odisha", "Puri", "Cuttack", "Kolkata", "Hyderabad", "Destination Wedding Photography"],
  founded: "2014",
  social: {
    instagram: "https://www.instagram.com/dms_productions_films?igsh=MWZzdm5xNmFnY3p0bw==",
    facebook: "https://www.facebook.com/digitalmediastudiobbsr/",
    youtube: "https://m.youtube.com/channel/UCf-e3-Xscp3HkqlGfxAQoQA",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

